import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { ROUTE_AUTH_LOGIN } from '../util/constants';

interface Props {
  children: JSX.Element;
}

// Gate for the partner shop portal: only users carrying the `partner_shop`
// role may enter. Everyone else is bounced to login.
export default function RequiredPartnerShop({ children }: Props) {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const location = useLocation();

  if (!currentUser.roles?.includes('partner_shop')) {
    return <Navigate to={ROUTE_AUTH_LOGIN} state={{ from: location }} />;
  }

  return children;
}
